function observerMap() {
    window.observerMap = (mapID, src) => {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    const script = document.createElement("script");
                    script.src = src;
                    document.getElementById(mapID).appendChild(script);
                    document.getElementById(mapID).classList.add('loader-hide');
                    observer.unobserve(entry.target);
                }
            });
        });
        observer.observe(document.getElementById(mapID));
    }
}

export default observerMap;